import React from 'react';

// third-party
import useI18n from 'i18n';
import { I18nextProvider } from 'react-i18next';

// ==============================|| LOCALIZATION ||============================== //

interface LocalsProps {
    children: React.ReactNode;
}

const Locales = ({ children }: LocalsProps) => {
    const i18n = useI18n();

    return (
        <>
            <I18nextProvider i18n={i18n}>{children}</I18nextProvider>
        </>
    );
};

export default Locales;
